import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import { Dashboard } from '~/domains/dashboard/components/Dashboard/Dashboard'
import type { DashboardTarget } from '~/domains/dashboard/types'
import useDocumentTitle from '~/utils/documentTitle'

type DashboardSearchParams = {
  target?: DashboardTarget
}

const DashboardPage = () => {
  useDocumentTitle('Tableau de bord')
  const navigate = useNavigate({ from: '/dashboard/' })
  const { target } = useSearch({ from: '/_dashboard/dashboard/' })
  const currentTarget: DashboardTarget = target ?? 'self'

  const handleTargetChange = (nextTarget: DashboardTarget) => {
    void navigate({
      search: { target: nextTarget === 'self' ? undefined : nextTarget }
    })
  }

  return (
    <Dashboard target={currentTarget} onTargetChange={handleTargetChange} />
  )
}

export const Route = createFileRoute('/_dashboard/dashboard/')({
  component: DashboardPage,
  validateSearch: (search: Record<string, unknown>): DashboardSearchParams => {
    const target = search.target
    if (typeof target === 'string' && target.startsWith('agency-')) {
      return { target }
    }
    return { target: undefined }
  }
})
